import React from 'react';

const ContentCV = () => (
  <div className="main-content">
    <div className="resume">
      <p style={{ fontSize: '2.5rem' }}>Coming Soon...</p>
      <p style={{ fontSize: '2rem' }}>In the meantime, <a href="/Kevin Randles Resume 2018.pdf">download</a> my resume.</p>
    </div>
  </div>
);

export default ContentCV;



// WEBPACK FOOTER //
// ./src/components/ContentCV.js